import { Component, Watch } from 'vue-property-decorator'
import Vue from '@src/vue'
import Member from '@src/data/member'
import { TrainingDay } from '@src/data/training-plan'
import { CreateElement } from 'vue'
import { Button } from '@src/elements/button/button'
import { Subtitle2 } from '@src/elements/typography/typography'
import { DatePicker } from '@src/elements/input/date-picker'
import AssignToMember from '@src/pages/assign-to-member/assign-to-member'
import { convertToLocalDate } from '@src/util/date-format'
import { TrainingPlanService } from '@src/service/training-plan'

@Component({
  computed: {
    trainingDays () {
      return this.$store.state.new_training_plan.trainingDays || []
    },
    member () {
      // @ts-ignore
      const raw = localStorage.getItem('member')
      let memberStorage = null
      if (raw) {
        try { memberStorage = JSON.parse(raw) } catch (_) { localStorage.removeItem('member') }
      }
      return this.$store.state.trainingMember || memberStorage
    },
    selectedTrainingPlan () {
      return this.$store.state.new_training_plan.selectedTrainingPlan
    }
  }
})
export class AssignPlanToMember extends Vue {

  protected selectedTrainingPlan

  protected member: Member | null

  protected startDate: string = ''

  private trainingDays: TrainingDay[]

  private showAssignMember: boolean = false
  private endDate: string = ''
  private emptyStartDate: boolean = true
  private emptyEndDate: boolean = true

  // member edit is allowed in the training plan builder, but not allowed if editing the member owned plan
  private allowMemberChange: boolean = true

  created () {
    this.$store.dispatch('setMemberForActiveTraining', this.member)
    if (this.member) {
      localStorage.setItem('member', JSON.stringify(this.member))
    }
  }

  beforeDestroy () {
    localStorage.removeItem('member')
  }

  beforeMount () {
    if (this.member) this.allowMemberChange = false
    if (this.selectedTrainingPlan.startDate) {
      this.startDate = convertToLocalDate(this.selectedTrainingPlan.startDate)
      this.computeEndDate(this.selectedTrainingPlan.totalDayCount)
    }
  }

  @Watch('trainingDays.length')
  trainingDaysChanged () {
    if (this.startDate) this.computeEndDate()
  }

  render (h: CreateElement) {
    // cannot edit current TP dates
    const readonlyDates = this.selectedTrainingPlan && !!this.selectedTrainingPlan.startDate && Date.parse(this.selectedTrainingPlan.startDate) < new Date().getTime()

    return <div slot='topMiddle'>
      <div class='assign-to-wrapper'>
        {this.allowMemberChange ? <div class={'assign-member-change'}>
            <Button class='assign-to-btn' type={this.member ? 'square-outline-blue' : 'square-outline-red'}
                    label={this.$t('ASSIGN')} click={this.showHideAssignToMember} />
            {this.member ? <Subtitle2 class='member-name'>{this.member!.firstName + ' ' + this.member!.lastName}</Subtitle2> : ''}
          </div>
          : <div class='member-assigned'>
            <Subtitle2 class='member-name'>{this.member!.firstName + ' ' + this.member!.lastName}</Subtitle2>
            <div class='date-pickers'>
              <DatePicker readonly={readonlyDates} allowPastDate={false}
                          class={this.emptyStartDate ? 'error' : ''} type='date'
                          value={this.startDate}
                          change={(value: string) => {
                            this.startDate = value
                            this.computeEndDate()
                          }} icon='util/calendar' label={`${this.$t('START_DATE')}:`} />
              <DatePicker readonly={readonlyDates} allowPastDate={false}
                          class={this.emptyEndDate ? 'error' : ''}
                          type='date'
                          value={this.endDate}
                          change={(value: string) => {
                            this.endDate = value
                            this.computeStartDate()
                          }} icon='util/calendar' label={`${this.$t('END_DATE')}:`} />
            </div>
          </div>
        }
        {this.showAssignMember ?
          <div class='assign-to-content'>
            {/* close will be triggered by click outside the assign component */}
            <AssignToMember initialSelectedMember={this.member || null} initialStartDate={this.startDate || ''} totalDays={this.trainingDays.length}
                            callback={this.persistMemberAssignmentData}
                            closeCallback={this.showHideAssignToMember} />
          </div>
          : ''}
      </div>
    </div>
  }

  showHideAssignToMember () {
    this.showAssignMember = !this.showAssignMember
  }

  computeStartDate () {
    this.startDate = TrainingPlanService.computeStartDate(this.endDate, this.trainingDays.length)
    if (!this.endDate) this.startDate = ''
    this.checkDates()
  }

  computeEndDate (totalTrainingDays?: number) {
    this.endDate = TrainingPlanService.computeEndDate(this.startDate, totalTrainingDays || this.trainingDays.length)
    this.checkDates()
  }

  checkDates () {
    this.emptyStartDate = this.startDate === 'Invalid Date' || !this.startDate || !this.endDate
    this.emptyEndDate = this.endDate === 'Invalid Date' || !this.endDate || !this.startDate
    this.$store.dispatch('setActivePlanStartDate', this.startDate)
  }

  persistMemberAssignmentData (member: Member, startDate: string) {
    // persist the id of the chosen member to be able to do the assign after the training plan is saved successfully
    this.$store.dispatch('setMemberForActiveTraining', member)
    this.$store.dispatch('setActivePlanStartDate', startDate)
    this.startDate = startDate
    if (member) this.showHideAssignToMember()
  }
}
